import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-item',
  templateUrl: './dashboard-item.component.html',
  styleUrls: ['./dashboard-item.component.css']
})
export class DashboardItemComponent implements OnInit {
  widthItem = '120px';
  heightItem = '110px';
  @Input('title') title = 'NoTitle';
  @Input('link') link = '';
  @Input('imageLink') imageLink = '';
  @Input('backgroundColor') backgroundColor = '#ccc';
  @Input('hoverColor') hoverColor = '#B3E5FC';
  @Output() itemClick = new EventEmitter<string>();
  hover = false;
  constructor() { }

  ngOnInit(): void {
  }

  itemClickFunc(value: string) {
    this.itemClick.emit(value);
  }

}
